module.exports = __webpack_public_path__ + "img/Banner-how-tod-drop-off-thp.287fcba4.png";